import api from "../utils/api";

const BASE = "/api/admin/shop-wifi-package-rules";

export async function getShopWifiPackageRules(params = {}) {
  return (await api.get(BASE, { params })).data;
}

export async function getShopWifiPackageRule(id) {
  return (await api.get(`${BASE}/${id}`)).data;
}

export async function createShopWifiPackageRule(payload) {
  return (await api.post(BASE, payload)).data;
}

export async function updateShopWifiPackageRule(id, payload) {
  return (await api.put(`${BASE}/${id}`, payload)).data;
}

export async function deleteShopWifiPackageRule(id) {
  return (await api.delete(`${BASE}/${id}`)).data;
}
